import { StyledTableBody } from './styles';
export const TableBody = StyledTableBody;

export default TableBody;
